<template>
  <div class="container-fluid">
    <titular><span class="d-block d-sm-inline">{{ $route.name }}</span> <span class="badge badge-secondary badge-pill" :class="{ 'invisible': isNaN(saturacion) }" :title="`Percentatge d'ocupació tècnica els primers ${mesesSaturacion} mesos`" v-tooltip>{{ saturacion }}%</span></titular>
    <div class="row mb-5">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-sm table-striped table-hover">
            <thead class="text-nowrap">
              <tr>
                <th class="position-sticky bg-white text-right"></th>
                <th v-for="(a, index) in meses" :key="index" scope="col" class="text-capitalize text-center">
                  <div>{{ getMonth(a.mes) }}</div>
                </th>
              </tr>
              <tr class="table-light">
                <td class="text-right position-sticky">Dedicació possible</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  {{ a.dedicacionPosible ? a.dedicacionPosible : "-" }}
                </td>
              </tr>
              <tr class="table-light" role="button">
                <td class="text-right position-sticky">Dedicació calculada</td>
                <td v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered">
                  <div v-if="a.dedicacionProgramadaTotal" class="d-flex justify-content-around align-items-center">
                    <span>{{ a.dedicacionProgramadaTotal }}</span>
                    <span class="badge ml-1" :style="getHsl(a.dedicacionProgramadaTotalPc / 100)">{{ isNaN(a.dedicacionProgramadaTotalPc) ? 0 : a.dedicacionProgramadaTotalPc }}%</span>
                  </div>
                  <template v-else>-</template>
                </td>
              </tr>
              <tr class="table-light">
                <th class="text-right position-sticky" scope="row">Hores lliures</th>
                <th v-for="(a, index) in meses" :key="index" scope="col" class="text-center table-bordered" :class="{ 'text-danger': a.horasLibres < 0 }">
                  {{ a.horasLibres }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(a, index) in planificadores" v-if="a.tienePlanificacion" :key="index">
                <td scope="row" class="position-sticky text-right text-nowrap" role="button" @click="trabajadorEscogido && trabajadorEscogido.id == a.id ? trabajadorEscogido = null : trabajadorEscogido = a" :class="trabajadorEscogido && trabajadorEscogido.id == a.id ? 'table-primary' : 'table-light'">
                  <div class="float-left mr-1"><i v-if="trabajadorEscogido && trabajadorEscogido.id == a.id" class="fa-solid fa-turn-down fa-flip-horizontal"></i></div>{{ a.nombre_completo }}
                </td>
                <td v-for="(b, bindex) in meses" :key="bindex" scope="col" class="table-bordered text-center text-nowrap">
                  <div class="d-flex justify-content-around align-items-center">
                    <span>{{ computados[index][bindex].horasLibres }}</span>
                    <span class="badge ml-1" :class="!isDedicacionProgramadaValida(index, bindex) && 'bg-danger'" :style="isDedicacionProgramadaValida(index, bindex) && getHsl(computados[index][bindex].dedicacionProgramadaTotalPc / 100)">{{ !isDedicacionProgramadaValida(index, bindex) ? "100%" : computados[index][bindex].dedicacionProgramadaTotalPc + "%" }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <h2 v-if="trabajadorEscogido" class="text-center mt-5 mb-3">Pla de dedicació<br>{{ trabajadorEscogido.nombre_completo }}</h2>
    <pla-dedicacio v-if="trabajadorEscogido" :editable="false" :trabajadorEscogido="trabajadorEscogido.id" />
    <div v-else class="row">
      <div class="col text-center text-muted">
        <i class="fas fa-10x mb-5 fa-question-circle"></i>
        <p class="lead">Selecciona un tècnic de la taula de dalt per veure el seu pla de dedicació.</p>
      </div>
    </div>
  </div>
</template>

<script>
import PlaDedicacio from "../components/TablaPlaDedicacio.vue";

export default {
  name: "DisponibilitatTecnica",
  inject: ["locale", "getMonth", "horasDiarias", "calcularDiasHabiles", "formatearDecimales"],
  components: {
    PlaDedicacio,
  },
  data() {
    return {
      loading: {},
      trabajadores: [],
      trabajadorEscogido: "",
      festivos_empresa: [],
      festivos_personales: [],
      planes: [],
      calculados: [],
      mesesSaturacion: 3,
      horasIndicadas: {},
    };
  },
  computed: {
    meses() {
      const meses = [];

      for (var i = 0; i < 12; i++) {
        const fecha = new Date(new Date().getFullYear(), new Date().getMonth() + i, 1);
        const diasEmpresa = this.festivos_empresa.filter((a) => new Date(a.festiu_empresa).getMonth() == fecha.getMonth() && new Date(a.festiu_empresa).getFullYear() == fecha.getFullYear());
        const computados = this.computados.filter(a => a.reduce((b, c) => b + c.dedicacionProgramada, 0) > 0).map(computado => computado[i]);
        const diasDisponibles = this.calcularDiasHabiles(new Date(fecha.getTime()), new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0));
        const dedicacionPosible = computados.reduce((a, b) => a + b.dedicacionPosible, 0);
        const dedicacionProgramadaTotal = computados.reduce((a, b) => a + b.dedicacionProgramadaTotal, 0);

        meses.push({
          anyo: fecha.getFullYear(),
          mes: fecha.getMonth(),
          diasDisponibles: diasDisponibles - diasEmpresa.length,
          dedicacionPosible,
          dedicacionProgramadaTotal,
          dedicacionProgramadaTotalPc: Math.round((dedicacionProgramadaTotal / dedicacionPosible) * 100),
          horasLibres: computados.reduce((a, b) => a + b.horasLibres, 0),
        });
      }

      return meses;
    },
    computados() {
      let computados = [];
      const totalMeses = 12;

      this.trabajadores.forEach(trabajador => {
        let meses = [];

        for (var i = 0; i < totalMeses; i++) {
          const fecha = new Date(new Date().getFullYear(), new Date().getMonth() + i, 1);
          const diasFestivos = this.festivos_personales.filter((a) => a.mes == fecha.getMonth() + 1 && a.any == fecha.getFullYear() && a.id_treballador == trabajador.id)?.reduce((a, b) => a + parseInt(b.dies), 0) ?? 0;
          const diasEmpresa = this.festivos_empresa.filter((a) => new Date(a.festiu_empresa).getMonth() == fecha.getMonth() && new Date(a.festiu_empresa).getFullYear() == fecha.getFullYear());
          const dedicacionProgramada = Math.round(this.planes.filter((b) => b.any == fecha.getFullYear() && b.mes == fecha.getMonth() + 1 && b.id_treballador == trabajador.id).reduce((a, b) => a + parseInt(b.total_hores), 0));
          const calculados = this.calculados.find(b => b.id_treballador == trabajador.id);
          const calculadosTotal = Object.values(calculados ?? {}).reduce((a, b) => a + parseFloat(b), 0);
          const diasDisponibles = this.calcularDiasHabiles(new Date(fecha.getTime()), new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0)) - diasEmpresa.length;
          const dedicacionPosible = Math.round((diasDisponibles - (diasFestivos ?? 0)) * ((this.horasDiarias * parseFloat(trabajador.jornada)) / 100));
          const horaIndicada = this.horasIndicadas[trabajador.id]?.[`${fecha.getFullYear()}${fecha.getMonth()}`];
          const noIndicadaEstructural = horaIndicada?.estructural === "" || horaIndicada?.estructural == null;
          const noIndicadaComercial = horaIndicada?.comercial === "" || horaIndicada?.comercial == null;
          const estructuralRelativo =  noIndicadaEstructural ? ((calculados?.estructural ?? 0) / (calculadosTotal ? calculadosTotal : 1)) * dedicacionPosible : horaIndicada.estructural;
          const comercialRelativo = noIndicadaComercial ? ((calculados?.comercial ?? 0) / (calculadosTotal ? calculadosTotal : 1)) * dedicacionPosible : horaIndicada.comercial;
          const dedicacionProgramadaTotal = Math.round(dedicacionProgramada + (isNaN(estructuralRelativo) ? 0 : estructuralRelativo) + (isNaN(comercialRelativo) ? 0 : comercialRelativo))

          meses.push({
            diasDisponibles: diasDisponibles - diasEmpresa.length,
            dedicacionProgramada,
            dedicacionProgramadaTotal,
            dedicacionProgramadaTotalPc: Math.round((dedicacionProgramadaTotal / dedicacionPosible) * 100),
            dedicacionPosible,
            horasLibres: dedicacionPosible - dedicacionProgramadaTotal,
          });
        }

        computados.push(meses);
      });

      return computados;
    },
    planificadores() {
      return this.trabajadores.map((a, i) => {
        return { ...a, tienePlanificacion: this.computados[i].reduce((a, b) => a + b.dedicacionProgramada, 0) > 0 };
      });
    },
    saturacion() {
      if (!this.meses.length) return;

      const primeros = this.meses.filter((a, index) => index < this.mesesSaturacion);

      return this.formatearDecimales(primeros.reduce((a, b) => a + b.dedicacionProgramadaTotal, 0) / primeros.reduce((a, b) => a + b.dedicacionPosible, 0) * 100).replace(",", ".");
    },
  },
  methods: {
    /**
     * Devuelve el valor Hue de rojo (1), amarillo (0.5) hasta verde (0).
     * 
     * @param value {Integer} de 0 a 1
     */
    getHsl(value) {
      if (value > 1) {
        value = 1;
      } else if (value < 0) {
        value = 0;
      }

      return `background: hsla(${((1 - value) * 120).toString(10)}, 100%, 50%, 0.66);`;
    },
    isDedicacionProgramadaValida(index, subindex) {
      const dedicacionProgramadaTotalPc = this.computados[index][subindex].dedicacionProgramadaTotalPc;

      return !isNaN(dedicacionProgramadaTotalPc) && dedicacionProgramadaTotalPc !== Infinity;
    }
  },
  mounted() {
    this.$http.get("api/treballadors?planificadors&order=nom").then((response) => (this.trabajadores = response.data));
    this.$http.get("api/festius_empresa").then((response) => (this.festivos_empresa = response.data ?? []));
    this.$http.get("api/plans").then((response) => (this.planes = response.data ?? []));
    this.$http.get("api/festius_personals").then((response) => (this.festivos_personales = response.data ?? []));
    this.$http.get(`api/projectes?${new URLSearchParams({ "mesesNoFacturables": this.meses.length, "todos": "" })}`).then(response => this.calculados = response.data ?? []);
    this.$http.get("api/hores_indicades")
      .then(response => {
        const horas = {};

        response.data.forEach(a => {
          if (!horas[a.id_treballador]) horas[a.id_treballador] = {};
          if (!horas[a.id_treballador][`${a.any}${a.mes - 1}`]) horas[a.id_treballador][`${a.any}${a.mes - 1}`] = {};

          horas[a.id_treballador][`${a.any}${a.mes - 1}`][a.tipus] = a.hores_indicades;
        });

        this.horasIndicadas = horas;
      });
  },
  watch: {
    meses(value) {
      this.$emit("reportarDisponibilidad", { "meses": value, "saturacion": this.saturacion });
    },
  },
};
</script>